// extracted by mini-css-extract-plugin
module.exports = {"history":"index-module--history--2jlUT","blockText":"index-module--blockText--2v6Yo","resume":"index-module--resume--RcJOr"};